
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indextYEf5WL1giRuPm9YlBZZhMZjFfMSe2wxREF2KdaoQTYMeta } from "F:/Github/dexon-technology/frontend/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93_459Y3VmqwfdD7pV9A2UYAjGESG6iRxe6NDiQHrHzH_45hcMeta } from "F:/Github/dexon-technology/frontend/pages/[...slug].vue?macro=true";
import { default as thank_45youpeNUN35CAv_TP0oekpba3ov2kEA1O1wTiZmxPeyXzUAMeta } from "F:/Github/dexon-technology/frontend/pages/thank-you.vue?macro=true";
import { default as indexg6jyPydpLajHhhO3eUWu3kXIWYQt3QiFUZSsXzslhP4Meta } from "F:/Github/dexon-technology/frontend/pages/news/index.vue?macro=true";
import { default as install_45pwaVqonoqGcCSUrXDzU9_454FIECzvjmdcYjVo3uWSVKPd0QMeta } from "F:/Github/dexon-technology/frontend/pages/install-pwa.vue?macro=true";
import { default as indexccMtO2G7XSdMMHwAjlg5FPgduTnWR7KLTtzJyP4fXqwMeta } from "F:/Github/dexon-technology/frontend/pages/submit-cv/index.vue?macro=true";
import { default as index0z69LF7Ynoq1EJxq3_45LHeG7VOwmXgS1JyoLV1__45DXLsMeta } from "F:/Github/dexon-technology/frontend/pages/industries/index.vue?macro=true";
import { default as indexNpicCuegQyq4Y7u2Bdf6F29IDdM0THqH_MtHKwKpx3QMeta } from "F:/Github/dexon-technology/frontend/pages/qr-services/index.vue?macro=true";
import { default as indexEV2A6qHLrJXaq8V8bfCjkIYN17G_qb2o1fIBUoggW2cMeta } from "F:/Github/dexon-technology/frontend/pages/case-studies/index.vue?macro=true";
import { default as pipeline_45categoriesIvNoT_45qTbt5xMdLait2CMA29o_LkCtE3u2ZM7cEITnMMeta } from "F:/Github/dexon-technology/frontend/pages/pipeline-categories.vue?macro=true";
import { default as indexwHN4iafaJ6AMzKOyPCgs_egFLKWKm8E8Eld_45L7Y1hYAMeta } from "F:/Github/dexon-technology/frontend/pages/questionnaire/index.vue?macro=true";
import { default as indexK2xhRLYVpeoVJnRKpLt4de86Kpla0U4LVESFJiEb9i8Meta } from "F:/Github/dexon-technology/frontend/pages/sustainability/index.vue?macro=true";
import { default as indexB9nC7dtl_bDDnIpf53FeepLzDFMPkBZhqvHSEl1J7_454Meta } from "F:/Github/dexon-technology/frontend/pages/career-at-dexon/index.vue?macro=true";
import { default as dexon_45opportunity_45dayXC5bPov1AEz_450QJrJzZZq4cAX7JDzHYtdz4xsv2f_45hcMeta } from "F:/Github/dexon-technology/frontend/pages/dexon-opportunity-day.vue?macro=true";
import { default as indexebC13a4I19zWmt6aBNyLR34UTNOJaP_x_KCeRfUXOjAMeta } from "F:/Github/dexon-technology/frontend/pages/pipeline-services/index.vue?macro=true";
import { default as indexGNfR89F92KyAva52wAQfQ_45qH_YvY2wx_457OqpEvNNdA4Meta } from "F:/Github/dexon-technology/frontend/pages/main-questionnaire/index.vue?macro=true";
import { default as indexrx6s3tzEgwnRmHYMgto69NyEzv0_45NkIhuefez5gfX5UMeta } from "F:/Github/dexon-technology/frontend/pages/inspection-services/index.vue?macro=true";
import { default as indexQA3nR86BNu_45IcgDFfSza4g7FpufVSKGSROGm8nWUIZEMeta } from "F:/Github/dexon-technology/frontend/pages/pipeline-services/resources/index.vue?macro=true";
import { default as index2rLdBAogsANSMJVy7kbsnt3V_45a7cwJw0J5RwSI9ioL0Meta } from "F:/Github/dexon-technology/frontend/pages/inspection-services/basic-ndt-service/index.vue?macro=true";
import { default as index3mL6Rldbl8wZMwvrREF2zr3ZxLHQhm8jwTUguK7cS_45QMeta } from "F:/Github/dexon-technology/frontend/pages/pipeline-services/intelligent-pigging/index.vue?macro=true";
import { default as index_45xwydos2F8PtM1OPUdP1UqiPpw810wTSPTsLefDcUAcMeta } from "F:/Github/dexon-technology/frontend/pages/inspection-services/advanced-ndt-services/index.vue?macro=true";
import { default as indexDgaic8DQ_z48xwSQh_45zYuz9MRUYY0yTz2Nk_EtHySWQMeta } from "F:/Github/dexon-technology/frontend/pages/inspection-services/inspection-services-rmi/index.vue?macro=true";
import { default as indextzlPT_452pGd3ZGi5fOjEjZQbf40JHyEDSrfchyQKGiwkMeta } from "F:/Github/dexon-technology/frontend/pages/inspection-services/advanced-ndt-services/tube-inspection-services/index.vue?macro=true";
import { default as component_45stubq3QTRbOAtRhaMGhX2Vi_fixJoPsvLl5tigYwV_ehPHsMeta } from "F:/Github/dexon-technology/frontend/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@vue+compiler-sfc@3.5.44_confbox@0.3.1_db0@0.3.4_dote_ryahtarybgy4ghlnucizrwdwwu/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubq3QTRbOAtRhaMGhX2Vi_fixJoPsvLl5tigYwV_ehPHs } from "F:/Github/dexon-technology/frontend/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@vue+compiler-sfc@3.5.44_confbox@0.3.1_db0@0.3.4_dote_ryahtarybgy4ghlnucizrwdwwu/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("F:/Github/dexon-technology/frontend/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    component: () => import("F:/Github/dexon-technology/frontend/pages/index.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("F:/Github/dexon-technology/frontend/pages/[...slug].vue")
  },
  {
    name: "slug___th",
    path: "/th/:slug(.*)*",
    component: () => import("F:/Github/dexon-technology/frontend/pages/[...slug].vue")
  },
  {
    name: "thank-you___en",
    path: "/thank-you",
    component: () => import("F:/Github/dexon-technology/frontend/pages/thank-you.vue")
  },
  {
    name: "thank-you___th",
    path: "/th/thank-you",
    component: () => import("F:/Github/dexon-technology/frontend/pages/thank-you.vue")
  },
  {
    name: "news___en",
    path: "/news",
    component: () => import("F:/Github/dexon-technology/frontend/pages/news/index.vue")
  },
  {
    name: "news___th",
    path: "/th/news",
    component: () => import("F:/Github/dexon-technology/frontend/pages/news/index.vue")
  },
  {
    name: "install-pwa___en",
    path: "/install-pwa",
    meta: install_45pwaVqonoqGcCSUrXDzU9_454FIECzvjmdcYjVo3uWSVKPd0QMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/install-pwa.vue")
  },
  {
    name: "install-pwa___th",
    path: "/th/install-pwa",
    meta: install_45pwaVqonoqGcCSUrXDzU9_454FIECzvjmdcYjVo3uWSVKPd0QMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/install-pwa.vue")
  },
  {
    name: "submit-cv___en",
    path: "/submit-cv",
    component: () => import("F:/Github/dexon-technology/frontend/pages/submit-cv/index.vue")
  },
  {
    name: "submit-cv___th",
    path: "/th/submit-cv",
    component: () => import("F:/Github/dexon-technology/frontend/pages/submit-cv/index.vue")
  },
  {
    name: "industries___en",
    path: "/industries",
    component: () => import("F:/Github/dexon-technology/frontend/pages/industries/index.vue")
  },
  {
    name: "industries___th",
    path: "/th/industries",
    component: () => import("F:/Github/dexon-technology/frontend/pages/industries/index.vue")
  },
  {
    name: "qr-services___en",
    path: "/qr-services",
    meta: indexNpicCuegQyq4Y7u2Bdf6F29IDdM0THqH_MtHKwKpx3QMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/qr-services/index.vue")
  },
  {
    name: "qr-services___th",
    path: "/th/qr-services",
    meta: indexNpicCuegQyq4Y7u2Bdf6F29IDdM0THqH_MtHKwKpx3QMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/qr-services/index.vue")
  },
  {
    name: "case-studies___en",
    path: "/case-studies",
    component: () => import("F:/Github/dexon-technology/frontend/pages/case-studies/index.vue")
  },
  {
    name: "case-studies___th",
    path: "/th/case-studies",
    component: () => import("F:/Github/dexon-technology/frontend/pages/case-studies/index.vue")
  },
  {
    name: "pipeline-categories___en",
    path: "/pipeline-categories",
    meta: pipeline_45categoriesIvNoT_45qTbt5xMdLait2CMA29o_LkCtE3u2ZM7cEITnMMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-categories.vue")
  },
  {
    name: "pipeline-categories___th",
    path: "/th/pipeline-categories",
    meta: pipeline_45categoriesIvNoT_45qTbt5xMdLait2CMA29o_LkCtE3u2ZM7cEITnMMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-categories.vue")
  },
  {
    name: "questionnaire___en",
    path: "/questionnaire",
    meta: indexwHN4iafaJ6AMzKOyPCgs_egFLKWKm8E8Eld_45L7Y1hYAMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/questionnaire/index.vue")
  },
  {
    name: "questionnaire___th",
    path: "/th/questionnaire",
    meta: indexwHN4iafaJ6AMzKOyPCgs_egFLKWKm8E8Eld_45L7Y1hYAMeta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/questionnaire/index.vue")
  },
  {
    name: "sustainability___en",
    path: "/sustainability",
    component: () => import("F:/Github/dexon-technology/frontend/pages/sustainability/index.vue")
  },
  {
    name: "sustainability___th",
    path: "/th/sustainability",
    component: () => import("F:/Github/dexon-technology/frontend/pages/sustainability/index.vue")
  },
  {
    name: "career-at-dexon___en",
    path: "/career-at-dexon",
    component: () => import("F:/Github/dexon-technology/frontend/pages/career-at-dexon/index.vue")
  },
  {
    name: "career-at-dexon___th",
    path: "/th/career-at-dexon",
    component: () => import("F:/Github/dexon-technology/frontend/pages/career-at-dexon/index.vue")
  },
  {
    name: "dexon-opportunity-day___en",
    path: "/dexon-opportunity-day",
    component: () => import("F:/Github/dexon-technology/frontend/pages/dexon-opportunity-day.vue")
  },
  {
    name: "dexon-opportunity-day___th",
    path: "/th/dexon-opportunity-day",
    component: () => import("F:/Github/dexon-technology/frontend/pages/dexon-opportunity-day.vue")
  },
  {
    name: "pipeline-services___en",
    path: "/pipeline-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-services/index.vue")
  },
  {
    name: "pipeline-services___th",
    path: "/th/pipeline-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-services/index.vue")
  },
  {
    name: "main-questionnaire___en",
    path: "/main-questionnaire",
    meta: indexGNfR89F92KyAva52wAQfQ_45qH_YvY2wx_457OqpEvNNdA4Meta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/main-questionnaire/index.vue")
  },
  {
    name: "main-questionnaire___th",
    path: "/th/main-questionnaire",
    meta: indexGNfR89F92KyAva52wAQfQ_45qH_YvY2wx_457OqpEvNNdA4Meta || {},
    component: () => import("F:/Github/dexon-technology/frontend/pages/main-questionnaire/index.vue")
  },
  {
    name: "inspection-services___en",
    path: "/inspection-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/index.vue")
  },
  {
    name: "inspection-services___th",
    path: "/th/inspection-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/index.vue")
  },
  {
    name: "pipeline-services-resources___en",
    path: "/pipeline-services/resources",
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-services/resources/index.vue")
  },
  {
    name: "pipeline-services-resources___th",
    path: "/th/pipeline-services/resources",
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-services/resources/index.vue")
  },
  {
    name: "inspection-services-basic-ndt-service___en",
    path: "/inspection-services/basic-ndt-service",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/basic-ndt-service/index.vue")
  },
  {
    name: "inspection-services-basic-ndt-service___th",
    path: "/th/inspection-services/basic-ndt-service",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/basic-ndt-service/index.vue")
  },
  {
    name: "pipeline-services-intelligent-pigging___en",
    path: "/pipeline-services/intelligent-pigging",
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-services/intelligent-pigging/index.vue")
  },
  {
    name: "pipeline-services-intelligent-pigging___th",
    path: "/th/pipeline-services/intelligent-pigging",
    component: () => import("F:/Github/dexon-technology/frontend/pages/pipeline-services/intelligent-pigging/index.vue")
  },
  {
    name: "inspection-services-advanced-ndt-services___en",
    path: "/inspection-services/advanced-ndt-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/advanced-ndt-services/index.vue")
  },
  {
    name: "inspection-services-advanced-ndt-services___th",
    path: "/th/inspection-services/advanced-ndt-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/advanced-ndt-services/index.vue")
  },
  {
    name: "inspection-services-inspection-services-rmi___en",
    path: "/inspection-services/inspection-services-rmi",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/inspection-services-rmi/index.vue")
  },
  {
    name: "inspection-services-inspection-services-rmi___th",
    path: "/th/inspection-services/inspection-services-rmi",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/inspection-services-rmi/index.vue")
  },
  {
    name: "inspection-services-advanced-ndt-services-tube-inspection-services___en",
    path: "/inspection-services/advanced-ndt-services/tube-inspection-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/advanced-ndt-services/tube-inspection-services/index.vue")
  },
  {
    name: "inspection-services-advanced-ndt-services-tube-inspection-services___th",
    path: "/th/inspection-services/advanced-ndt-services/tube-inspection-services",
    component: () => import("F:/Github/dexon-technology/frontend/pages/inspection-services/advanced-ndt-services/tube-inspection-services/index.vue")
  },
  {
    name: component_45stubq3QTRbOAtRhaMGhX2Vi_fixJoPsvLl5tigYwV_ehPHsMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubq3QTRbOAtRhaMGhX2Vi_fixJoPsvLl5tigYwV_ehPHs
  },
  {
    name: component_45stubq3QTRbOAtRhaMGhX2Vi_fixJoPsvLl5tigYwV_ehPHsMeta?.name,
    path: "/th/sitemap.xml",
    component: component_45stubq3QTRbOAtRhaMGhX2Vi_fixJoPsvLl5tigYwV_ehPHs
  }
]